import { TypedUseSelectorHook, useDispatch, useSelector, shallowEqual } from 'react-redux'
import type { RootState, AppDispatch } from './store'
import { store, useTypedSelector } from './store'



//import React, { useEffect, useState, useRef } from "react";

import { useAuth, ErrorContext, AuthContextProps } from 'react-oidc-context';
import { profileCreateMatch, useGetLoggedInUserProfileQuery } from '../features/profilesSlice';
import { skipToken } from '@reduxjs/toolkit/query';
import { getUserAttributes, reset } from '../features/userAttributesSlice';
import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';
//import { useGetMessagingQuery } from '../features/ChatSlice';
import { SigninRedirectArgs, User, UserManagerEvents } from 'oidc-client-ts';
import { useLogToBackEndMutation } from '../features/utilitySlice'
import { printError } from './utils';
// import { activateMarker } from '../features/activeMarkers';
// import { showCareCenters, showWarriors } from '../features/filterSlice';
// import { aiAnalyticsApi } from '../features/aiAnalytics';
import { useCustomAuth, useCustomAuthInterface } from './auth/useCustomAuth';
import { clearSessionRTK, CustomSession, selectAuthMethod, setAuthenticated, setAuthReady, setSessionForRTK } from '../features/userTokenManagementSlice';
import { CUSTOM_METHOD, HOSTED_UI_REDIRECT, } from './auth/utils';
import { baseName } from '..';
import { AuthBootstrapResult, useAuthBootstrap } from './AuthBootstrap';
import { AuthBootstrapContext } from '../AuthBootstrapProvider';

//import { setAuthToken } from './authiutils';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
type DispatchFunc = () => AppDispatch
export const useAppDispatch: DispatchFunc = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector




interface useAuthProfileInterface {
    authStatus: string,
    sub: string | null | undefined,
    isFederated: boolean | null,
    profile: any,
    isLoading: boolean,
    isSuccess: boolean,
    isError: boolean | ErrorContext | undefined,
    error: any,
    //userAttributesStateStatus: any
    authUser: any,
    // //userAttributesState: any,
    // messagingData: any,
    // isSuccessMessaging: boolean,
    // isUninitializedMessaging: Boolean,
    // messagingReady: boolean,
    //isErrorMessaging: boolean, isLoadingMessaging: boolean,
    //errorMessaging: any, //messagingRefetch: () => Promise<any>
    deleteTriggered: boolean,
    //refetchProfile: () => Promise<any>,

    //auth Errors
    user: User | null | undefined, isAuthenticated: boolean, errorAuthenticator: ErrorContext | undefined, eventsAuthenticator: UserManagerEvents
    isLoadingAuth: boolean, isAuthSuccess: boolean,
    //isLoadingAuth: boolean, isAuthenticated: boolean, errorAuthenticator: ErrorContext | undefined, eventsAuthenticator: UserManagerEvents, isAuthSuccess: boolean,
    //profile retireival errors
    isProfileSuccess: boolean, isProfileError: boolean, isLoadingProfile: boolean, //profileRefetch: () => Promise<any>,
    profileError: any,
    //messaging retireival errors


    isSignOutErrorButLoggedIn: boolean | undefined,
    customAuth: useCustomAuthInterface,
    clearLocalSesstion: () => Promise<void>,


    authMethod: typeof CUSTOM_METHOD | typeof HOSTED_UI_REDIRECT | undefined,
    auth: AuthContextProps,
    logoutFromAnyAuthMethod: () => Promise<void>
}

export const getVersion = (): string => {
    return `${process.env.REACT_APP_VERSION} ${process.env.REACT_APP_BUILD_TIME ? new Date(process.env.REACT_APP_BUILD_TIME).toLocaleString(undefined, { dateStyle: 'long', timeStyle: 'short', }) : 'Unknown'}`
}

// export const useAuthProfile_Old = (arg?: any): useAuthProfileInterface => {
//     // 1. Initialize typed dispatch hook
//     const authMethod = useAppSelector(selectAuthMethod)
//     const dispatch = useAppDispatch();
//     const [deleteTriggered, SetdeleteTriggered] = useState(false)
//     const auth = useAuth();//(context) => [context.user])

//     const { user: regularUser, activeNavigator, isLoading: isLoadingAuth, isAuthenticated: regularIsAuthenticated, error: errorAuthenticator, events: eventsAuthenticator, signinRedirect } = auth
//     // 2. Get state from custom Cognito flow
//     const customAuth: useCustomAuthInterface = useCustomAuth();
//     const user = customAuth?.user ? customAuth.user : regularUser
//     const isAuthenticated = customAuth?.isAuthenticated ? customAuth.isAuthenticated : regularIsAuthenticated
//     const sub: string | undefined | null = customAuth?.user?.sub ?? user?.profile?.sub //: userAttributesState.userAttributes?.sub ?? userAttributesState?.HUBSignInEventData?.setSignInDetails?.userId ?? null

//     const isSignOutErrorButLoggedIn = errorAuthenticator && errorAuthenticator.source.includes("signoutRedirect") && isAuthenticated//TODO add custom flow errors

//     if (errorAuthenticator) {
//         console.log(`errorAuthenticator in Hook`, errorAuthenticator, 'isAuthenticated', isAuthenticated, 'isLoadingAuth', isLoadingAuth)
//     }

//     const isDelteProfileStatus = useSelector((state: RootState) => {
//         const foundKey = state.profileApi.mutations ? Object.keys(state.profileApi.mutations).find(mkey => state.profileApi.mutations[mkey]?.endpointName === 'DeleteUserData') : undefined
//         //console.log(`isDelteProfileLoading  status: ${foundKey ? state.profileApi.mutations[foundKey]?.status : 'key not found'} `)
//         return foundKey ? state.profileApi.mutations[foundKey]?.status : 'uninitialized'//=== "pending"
//     });

//     useEffect(() => {
//         if (customAuth?.isLoading || isLoadingAuth) {
//             return
//         }
//         if (authMethod === CUSTOM_METHOD && customAuth.isAuthenticated && customAuth && customAuth.session) {//||!isLoadingAuth) {
//             const tokenPayload = { sub: customAuth.session.profile?.sub, id_token: customAuth.session.id_token, access_token: customAuth.session.access_token }
//             //dont need to update state here as that's done the customAuth Hook
//             // dispatch(setAuthenticated(isAuthenticated));          
//             //     // If data is found in localStorage, load it into Redux
//             //     dispatch(setSessionForRTK(tokenPayload));
//             //     dispatch(setAuthenticated(true))
//             //     dispatch(setAuthReady(true));          
//         } else if (isAuthenticated) {
//             if (regularUser) {
//                 const newSession: CustomSession = { sub: regularUser?.profile?.sub, expires_at: regularUser.expires_at, profile: regularUser.profile, id_token: regularUser?.id_token!, access_token: regularUser?.access_token }
//                 dispatch(setSessionForRTK({ newSession, authMethod: HOSTED_UI_REDIRECT }))
//                 dispatch(setAuthenticated(true))
//                 dispatch(setAuthReady(true));
//             }
//         } else {
//             if (!customAuth?.isLoading) {
//                 //dispatch(clearSessionRTK())
//             }
//         }
//     }, [dispatch, customAuth.isAuthenticated, isLoadingAuth, isAuthenticated, regularUser, regularUser?.profile?.sub, regularUser?.id_token, regularUser?.access_token]);

//     useEffect(() => {
//         if (isDelteProfileStatus === 'pending') {//&& !deleteTriggered) {
//             SetdeleteTriggered(true)
//         } //else {            SetdeleteTriggered(false)        }
//     }, [isDelteProfileStatus])


//     //EXPECTGING EMAIL FROM OIDC AND PHONE FROM CUSTOM, EVEN IF oidc has phone
//     const nickname = user?.profile?.nickname ?? ''// user?.profile? user?.profile["cognito:username"]:''//nickname//userAttributesState.userAttributes ? userAttributesState.userAttributes.nickname ?? "" : ""
//     const email = user?.profile?.email//userAttributesState.userAttributes ? userAttributesState.userAttributes.email ?? "" : ""
//     const idTokenClaims = user?.profile;//TODO

//     const isFederated: boolean | null = user?.profile ?
//         (user.profile["cognito:username"] as string).toLowerCase().includes('facebook_') ? true :
//             (user?.profile["cognito:username"] as string).toLowerCase().includes('google_') ? true :
//                 (user?.profile["cognito:username"] as string).toLowerCase().includes('signinwithapple_') ? true : false : false// idTokenClaims?.identities?.[0]?.providerName.includes('cognito-idp')//userAttributesState.userAttributes ? userAttributesState.userAttributes.isFederated ?? null : null




//     var getUserProfileArg: any// 'unique symbol | profileCreateMatch'
//     if (errorAuthenticator) {
//         //load guest profile
//         getUserProfileArg = {
//             iamId: 'unauthenticated',
//             nickname: 'Guest', //will be updated by the backend
//             email: '', //will be updated by the backend''
//             //zipCode: user ? email : null,
//             isFederated: false//will be updated by the backend''
//         }
//     } else
//         if ((customAuth.user && customAuth.isAuthenticated) || (!isLoadingAuth && ((sub && (email || customAuth?.user?.phone_number)) || (!isAuthenticated)) && !deleteTriggered)) {
//             getUserProfileArg = {
//                 iamId: sub ?? "unauthenticated",
//                 nickname: nickname,// user ? nickname : userAttributesState.userAttributes?.nickname ?? null,
//                 email: email,//user ? email : userAttributesState.userAttributes?.email ?? null,
//                 phone: customAuth?.user?.phone_number,//zipCode: user ? email : null,
//                 isFederated: isFederated,
//                 sms_consent: authMethod === CUSTOM_METHOD  //all SMS logins consented
//             }
//             //setAuthToken({ token: user?.access_token, sub: isAuthenticated ? user?.profile?.sub : 'unauthenticated' })
//         } else if (deleteTriggered) {
//             getUserProfileArg = {
//                 iamId: "unauthenticated",
//                 // nickname: nickname,// user ? nickname : userAttributesState.userAttributes?.nickname ?? null,
//                 // email: email,//user ? email : userAttributesState.userAttributes?.email ?? null,
//                 // phone: customAuth?.user?.phone_number,//zipCode: user ? email : null,
//                 // isFederated: isFederated
//             }
//         } else {
//             getUserProfileArg = skipToken
//         }
//     const { data: profile, isLoading: isLoadingProfile, isSuccess: isProfileSuccess, isError: isProfileError, error: profileError, refetch: profileRefetch } = useGetLoggedInUserProfileQuery(getUserProfileArg)

//     const loggedInId = (isProfileSuccess /*&& authStatus === 'authenticated'*/ && profile.id && !deleteTriggered// ( isDelteProfileStatus === 'fulfilled' ||  isDelteProfileStatus === 'uninitialized' )
//     ) ? profile.id : skipToken

//     //const { data: messagingData, isUninitialized: isUninitializedMessaging, isSuccess: isSuccessMessaging, isLoading: isLoadingMessaging, isError: isErrorMessaging, error: errorMessaging, refetch: messagingRefetch } = useGetMessagingQuery(loggedInId)
//     //const messagingReady: boolean = isSuccessMessaging ? (messagingData.userCreationResults.secret1 ? true : false) : false


//     const isLoading = isLoadingProfile || getUserProfileArg === skipToken || isLoadingAuth || customAuth.isLoading//|| isLoadingMessaging
//     const isSuccess = isProfileSuccess /*&& isSuccessMessaging */ && !errorAuthenticator
//     const isError = isProfileError || errorAuthenticator //|| isErrorMessaging

//     const error = isProfileError ? profileError : undefined //isErrorMessaging ? errorMessaging : undefined
//     const authStatus = (isProfileSuccess && profile.iam_id === 'unauthenticated') ? 'unauthenticated' : isLoadingAuth ? 'loading' : isAuthenticated ? 'authenticated' : 'unauthenticated' //authStatus, 

//     const logoutFromAnyAuthMethod = async () => {
//         if (authMethod === CUSTOM_METHOD) {//'sms-cognito'){
//             await customAuth.logout()
//         } else {
//             await auth.removeUser();
//             auth.signoutRedirect({
//                 state: { baseName },
//                 post_logout_redirect_uri: auth.settings?.post_logout_redirect_uri,
//                 extraQueryParams: {
//                     client_id: auth.settings?.client_id,//"7amp8un1r51k9p7qqj00jovh75",
//                     redirect_uri: auth.settings?.post_logout_redirect_uri ?? false,//"http://localhost:4000/map/admin/out/",
//                     logout_uri: auth.settings?.post_logout_redirect_uri ?? false,//"http://localhost:4000/map/admin/out/",
//                     response_type: "code",
//                     state_data: baseName
//                 },
//             })
//         }
//     }

//     const clearLocalSesstion = async () => {
//         //if( authMethod ===  CUSTOM_METHOD ){//'sms-cognito'){
//         customAuth.clearLocalAndRTKSesstion()
//         //} else{
//         //await auth.signoutSilent()
//         await auth.removeUser();
//         await auth.clearStaleState()
//         //}

//     }

//     return {
//         authStatus: authStatus,
//         sub,
//         authUser: user, /*userAttributesState,*/ isFederated, profile, isLoading, isSuccess, isError, error, //userAttributesStateStatus,
//         deleteTriggered,
//         //messaging retireival errors        
//         //messagingReady, isSuccessMessaging, messagingData, errorMessaging, isErrorMessaging,   //&& !isError && !isLoading,         
//         //messagingReady: false, isSuccessMessaging: false, isErrorMessaging : true,                 
//         //isLoadingMessaging, isUninitializedMessaging: isUninitializedMessaging,// messagingRefetch,

//         //auth Errors
//         user, isLoadingAuth, isAuthenticated, errorAuthenticator, eventsAuthenticator, isAuthSuccess: !isLoadingAuth && !errorAuthenticator,
//         //errorAuthenticator: isLoadingAuth ? undefined : new Error('Something went wrong')  as ErrorContext, //to mock

//         //profile retireival errors
//         isProfileSuccess, isProfileError, isLoadingProfile, profileError, //profileRefetch,
//         isSignOutErrorButLoggedIn,
//         customAuth,
//         authMethod: authMethod, //customAuth.session ? CUSTOM_METHOD : "cognito hosted redirect"
//         auth,
//         logoutFromAnyAuthMethod,
//         clearLocalSesstion
//     }

// }



export const useAuthProfile = () => {
    const ctx = useContext(AuthBootstrapContext);
    if (!ctx) {
        throw new Error('useAuthState must be used inside AuthBootstrapProvider');
    }
    return ctx;
};




// export function resetGetSearchByStoryCache( refetch: boolean = false): void {
//   const queries = store.getState().aiAnalytics.queries;

//   Object.values(queries)
//     .filter((query: any) => query?.endpointName === 'getSearchByStory')
//     .forEach((query: any) => {
//       // Clear cached data
//       store.dispatch(
//         aiAnalyticsApi.util.updateQueryData(
//           'getSearchByStory',
//           query.originalArgs,
//           () => undefined
//         )
//       );

//       // Optionally refetch
//       if (refetch) {
//         store.dispatch(
//           aiAnalyticsApi.endpoints.getSearchByStory.initiate(
//             query.originalArgs,
//             { forceRefetch: true }
//           )
//         );
//       }
//     });
// }
